/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon16Solid = forwardRef('ArrowDim1DiagRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5.875a1.125 1.125 0 0 0 0 2.25h1.784l-8.159 8.159V9.5a1.125 1.125 0 0 0-2.25 0v4c0 .898.728 1.625 1.625 1.625h4a1.125 1.125 0 0 0 0-2.25H4.716l8.159-8.159V6.5a1.125 1.125 0 0 0 2.25 0v-4c0-.897-.727-1.625-1.625-1.625h-4Z" })));
});
